<template>
	<v-list-item
		class='border my-3 light-border'
		elevation='0'
		style='min-height: 61px'
	>
		<v-list-item-content class='py-2' style='min-height: 61px'>
			<v-list-item-title class='font-weight-bold primary--text'>
				Für Geschäftskunden
			</v-list-item-title>
			<v-list-item-subtitle>
				<v-checkbox
					v-model='isBusiness'
					label='Nettopreise anzeigen'
					color='#C62929'
					hide-details
					:ripple='false'
					class='v-check font-weight-regular'
				/>
			</v-list-item-subtitle>
		</v-list-item-content>
	</v-list-item>
</template>

<script>
export default {
	name: 'MobileOptionDrawer',

	data() {
		return {
      windowWidth: 0,
      isBusiness: false
		}
	},

	computed: {
    isXss() {
      return this.windowWidth < 400
    },
	},
  watch: {
    isBusiness: function(val) {
      this.$store.isBusinessCustomer = val;
      this.$bus.$emit('filters-updated');
    }
  },


  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
	mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize)
    this.isBusiness = this.$store.isBusinessCustomer;

  },

	methods: {
    onResize() {
      this.windowWidth = window.innerWidth
    },
	}
}
</script>

<style lang='scss'>
#mobile-catalog .v-dialog__content {
	align-items: flex-end;
	padding-bottom: 48px;
}

#filter-list-mobile .v-list-group__header.v-list-item {
	padding: 0 12px !important;
}
</style>

<style lang='scss' scoped>
@import 'src/styles/variables';

#drawer-actions {
	position: fixed;
	bottom: 16px;
  width: 100%;
}

.delete-actions .v-btn {
	min-width: 172px !important;
}
</style>